import dayjs from 'dayjs';
import { generateUniqueStepCode } from '../utils/sopUtils';

const useStepFormInit = () => {
  // 处理时间解析
  const parseExecuteTime = (executeTime) => {
    if (!executeTime) return null;

    try {
      console.log('解析executeTime:', executeTime, '类型:', typeof executeTime);

      if (typeof executeTime === 'string') {
        const simplifiedTime = executeTime.split('.')[0];
        let timeValue = dayjs(simplifiedTime, 'HH:mm:ss');

        if (!timeValue.isValid()) {
          timeValue = dayjs(`2000-01-01 ${simplifiedTime}`);
          console.log('尝试添加日期解析:', `2000-01-01 ${simplifiedTime}`, '结果:', timeValue.isValid());
        }

        if (!timeValue.isValid()) {
          const timeMatch = executeTime.match(/T(\d{2}:\d{2}:\d{2})/);
          if (timeMatch && timeMatch[1]) {
            timeValue = dayjs(`2000-01-01 ${timeMatch[1]}`);
            console.log('从ISO提取时间:', timeMatch[1], '结果:', timeValue.isValid());
          } else {
            timeValue = dayjs(executeTime);
          }
        }

        if (!timeValue.isValid()) {
          console.warn('无法解析executeTime:', executeTime);
          timeValue = dayjs('09:00:00', 'HH:mm:ss');
        }

        return timeValue;
      } else if (dayjs.isDayjs(executeTime)) {
        return executeTime;
      } else {
        console.warn('executeTime类型异常:', typeof executeTime);
        return dayjs('09:00:00', 'HH:mm:ss');
      }
    } catch (e) {
      console.error('解析executeTime失败:', e);
      return dayjs('09:00:00', 'HH:mm:ss');
    }
  };

  // 处理定时SOP的日期时间合并
  const parseScheduledDateTime = (currentStep) => {
    let dateTimeValue = null;
    
    if (currentStep.scheduledDate && currentStep.scheduledTime) {
      try {
        let dateStr = '';
        let timeStr = '';
        
        if (typeof currentStep.scheduledDate === 'string') {
          dateStr = currentStep.scheduledDate;
        } else if (dayjs.isDayjs(currentStep.scheduledDate)) {
          dateStr = currentStep.scheduledDate.format('YYYY-MM-DD');
        } else {
          dateStr = dayjs().format('YYYY-MM-DD');
        }
        
        if (typeof currentStep.scheduledTime === 'string') {
          timeStr = currentStep.scheduledTime;
        } else if (dayjs.isDayjs(currentStep.scheduledTime)) {
          timeStr = currentStep.scheduledTime.format('HH:mm:ss');
        } else {
          timeStr = '09:00:00';
        }
        
        dateTimeValue = dayjs(`${dateStr} ${timeStr}`);
        
        if (!dateTimeValue.isValid()) {
          console.warn('合并日期时间无效，使用当前时间');
          dateTimeValue = dayjs();
        }
      } catch (e) {
        console.error('合并日期和时间失败:', e);
        dateTimeValue = dayjs();
      }
    } else if (currentStep.scheduledDateTime) {
      if (typeof currentStep.scheduledDateTime === 'string') {
        dateTimeValue = dayjs(currentStep.scheduledDateTime);
      } else if (dayjs.isDayjs(currentStep.scheduledDateTime)) {
        dateTimeValue = currentStep.scheduledDateTime;
      }
    }
    
    return dateTimeValue;
  };

  // 处理步骤级别目标规则
  const parseTargetRules = (currentStep) => {
    const initialValues = {
      stepTargetType: 'TAG',
      stepTargetIds: []
    };

    if (currentStep.targetRules && currentStep.targetRules.length > 0) {
      const targetRule = currentStep.targetRules[0];

      initialValues.stepTargetType = targetRule.targetType;

      if (targetRule.targetIds) {
        try {
          let targetIds = [];

          if (typeof targetRule.targetIds === 'string') {
            try {
              targetIds = JSON.parse(targetRule.targetIds);
              if (!Array.isArray(targetIds)) {
                targetIds = [targetRule.targetIds];
              }
            } catch (e) {
              targetIds = [targetRule.targetIds];
            }
          } else if (Array.isArray(targetRule.targetIds)) {
            targetIds = targetRule.targetIds;
          } else if (targetRule.targetIds) {
            targetIds = [String(targetRule.targetIds)];
          }

          initialValues.stepTargetIds = targetIds.map(id => String(id));
          console.log("设置目标IDs:", initialValues.stepTargetIds);
        } catch (e) {
          console.error("解析步骤目标ID失败:", e);
          initialValues.stepTargetIds = [];
        }
      }
    }

    return initialValues;
  };

  // 处理步骤级别执行人
  const parseEmployeeIds = (currentStep) => {
    if (!currentStep.employeeIds) {
      return [];
    }

    let employeeIds = [];

    if (typeof currentStep.employeeIds === 'string') {
      try {
        employeeIds = JSON.parse(currentStep.employeeIds);
        if (!Array.isArray(employeeIds)) {
          employeeIds = [currentStep.employeeIds];
        }
      } catch (e) {
        employeeIds = [currentStep.employeeIds];
      }
    } else if (Array.isArray(currentStep.employeeIds)) {
      employeeIds = currentStep.employeeIds;
    } else if (currentStep.employeeIds) {
      employeeIds = [String(currentStep.employeeIds)];
    }

    return employeeIds.map(id => String(id));
  };

  // 处理attachments预览URL
  const processAttachments = (currentStep, handleUpdatePreviewUrls) => {
    if (currentStep.actionParams && currentStep.actionParams.attachments && Array.isArray(currentStep.actionParams.attachments)) {
      currentStep.actionParams.attachments.forEach(attachment => {
        let mediaId = null;
        let ossUrl = null;

        if (attachment.msgtype === 'image' && attachment.image) {
          // 优先使用media_id，如果没有则尝试pic_url作为标识符
          mediaId = attachment.image.media_id || attachment.image.pic_url;
          ossUrl = attachment.image.oss_url || attachment.image.ossUrl;
        } else if (attachment.msgtype === 'video' && attachment.video) {
          mediaId = attachment.video.media_id;
          ossUrl = attachment.video.oss_url || attachment.video.ossUrl;
          console.log(`从视频附件提取预览URL: ${mediaId} -> ${ossUrl}`);
        } else if (attachment.msgtype === 'file' && attachment.file) {
          mediaId = attachment.file.media_id;
          ossUrl = attachment.file.oss_url || attachment.file.ossUrl;
        } else if (attachment.msgtype === 'miniprogram' && attachment.miniprogram) {
          mediaId = attachment.miniprogram.pic_media_id;
          ossUrl = attachment.miniprogram.pic_oss_url;
          console.log(`从小程序附件提取缩略图预览URL: ${mediaId} -> ${ossUrl}`);
        }

        if (mediaId && ossUrl && typeof handleUpdatePreviewUrls === 'function') {
          console.log(`从attachments提取预览URL: ${mediaId} -> ${ossUrl}`);
          handleUpdatePreviewUrls({ [mediaId]: ossUrl });
        }
      });
    }
  };

  // 处理消息类型的表单参数
  const processMessageParams = (currentStep) => {
    const initialValues = {};

    // 查找文本消息，设置到表单
    const textMessage = currentStep.messageList?.find(msg => msg.type === 'TEXT');
    if (textMessage) {
      initialValues.actionParams = {
        content: textMessage.params.content || ''
      };
    }

    // 处理其他类型消息的表单值
    const firstNonTextMsg = currentStep.messageList?.find(msg => msg.type !== 'TEXT');
    if (firstNonTextMsg) {
      if (!initialValues.actionParams) {
        initialValues.actionParams = {};
      }

      if (firstNonTextMsg.type === 'LINK') {
        Object.assign(initialValues.actionParams, {
          title: firstNonTextMsg.params.title || '',
          description: firstNonTextMsg.params.description || '',
          url: firstNonTextMsg.params.url || '',
          picUrl: firstNonTextMsg.params.picUrl || ''
        });
      } else if (firstNonTextMsg.type === 'MINIPROGRAM') {
        Object.assign(initialValues.actionParams, {
          title: firstNonTextMsg.params.title || '',
          appid: firstNonTextMsg.params.appid || '',
          pagepath: firstNonTextMsg.params.pagepath || '',
          thumbMediaId: firstNonTextMsg.params.thumbMediaId || '',
          thumbMediaId_ossUrl: firstNonTextMsg.params.thumbMediaId_ossUrl || ''
        });
      } else {
        initialValues.actionParams.mediaId = firstNonTextMsg.params.mediaId || '';

        if (firstNonTextMsg.params.ossUrl || firstNonTextMsg.params.mediaId_ossUrl) {
          initialValues.actionParams.ossUrl = firstNonTextMsg.params.ossUrl || firstNonTextMsg.params.mediaId_ossUrl;
        }

        if (firstNonTextMsg.type === 'VIDEO') {
          initialValues.actionParams.videoMediaId = firstNonTextMsg.params.mediaId || '';

          if (firstNonTextMsg.params.ossUrl || firstNonTextMsg.params.mediaId_ossUrl) {
            initialValues.actionParams.videoMediaId_ossUrl = firstNonTextMsg.params.ossUrl || firstNonTextMsg.params.mediaId_ossUrl;
            // 同时设置ossUrl字段以保持兼容
            initialValues.actionParams.ossUrl = firstNonTextMsg.params.ossUrl || firstNonTextMsg.params.mediaId_ossUrl;
          }
        }
      }
    }

    return initialValues;
  };

  // 处理朋友圈类型的表单参数
  const processMomentsParams = (currentStep) => {
    const initialValues = {};

    const textMoment = currentStep.momentsList?.find(m => m.type === 'MOMENT_TEXT');
    if (textMoment && textMoment.params) {
      initialValues.actionParams = {
        content: textMoment.params.content || ''
      };
    }

    return initialValues;
  };

  // 主要的初始化函数
  const initFormData = (
    currentStep,
    isScheduled,
    form,
    restoreFromMessageList,
    restoreFromMomentsList,
    initializeInputBoxes,
    handleUpdatePreviewUrls
  ) => {
    if (!currentStep) {
      // 新建步骤的默认值
      initializeInputBoxes('MESSAGE');
      initializeInputBoxes('MOMENTS');

      const formInitialValues = {
        actionParams: { content: '' },
        stepCode: generateUniqueStepCode()
      };

      if (isScheduled) {
        formInitialValues.stepTargetType = 'TAG';
        formInitialValues.stepTargetIds = [];
        formInitialValues.stepEmployeeIds = [];
        formInitialValues.scheduledDateTime = null;
      } else {
        formInitialValues.timeOffsetDays = 1;
        formInitialValues.executeTime = null;
      }

      form.setFieldsValue(formInitialValues);
      return;
    }

    console.log("初始化现有步骤表单 - 类型:", currentStep.type);
    console.log("当前步骤数据:", currentStep);

    // 基本表单值
    const initialValues = {
      name: currentStep.name,
      description: currentStep.description || '',
      stepCode: currentStep.stepCode,
      type: currentStep.type,
      actionType: currentStep.actionType
    };

    // 处理时间字段
    if (isScheduled) {
      initialValues.scheduledDateTime = parseScheduledDateTime(currentStep);
    } else {
      initialValues.timeOffsetDays = currentStep.timeOffsetDays || 1;
      initialValues.executeTime = parseExecuteTime(currentStep.executeTime);
      console.log('设置到表单的executeTime值:', initialValues.executeTime);
    }

    // 处理attachments预览URL
    processAttachments(currentStep, handleUpdatePreviewUrls);

    // 根据步骤类型处理数据
    if (currentStep.type === 'MESSAGE') {
      restoreFromMessageList(currentStep.messageList);
      
      // 从attachments中提取预览URL (备用方案)
      processAttachments(currentStep, handleUpdatePreviewUrls);
      
      // 处理消息参数
      const messageParams = processMessageParams(currentStep);
      Object.assign(initialValues, messageParams);
    } else if (currentStep.type === 'TAG') {
      if (currentStep.actionParams) {
        let tagParams = {};

        if (typeof currentStep.actionParams === 'string') {
          try {
            tagParams = JSON.parse(currentStep.actionParams);
          } catch (e) {
            console.error('解析TAG actionParams失败:', e);
            tagParams = {};
          }
        } else if (typeof currentStep.actionParams === 'object') {
          tagParams = currentStep.actionParams;
        }

        initialValues.actionParams = {
          tagId: tagParams.tagId
        };
      }
    } else if (currentStep.type === 'MOMENTS') {
      restoreFromMomentsList(currentStep.momentsList);
      
      // 从attachments中提取预览URL (备用方案)
      processAttachments(currentStep, handleUpdatePreviewUrls);
      
      // 处理朋友圈参数
      const momentsParams = processMomentsParams(currentStep);
      Object.assign(initialValues, momentsParams);
    }

    // 处理定时SOP的步骤级别设置
    if (isScheduled) {
      console.log("处理定时SOP步骤级别设置...");
      console.log("步骤级别目标规则:", currentStep.targetRules);
      console.log("步骤级别执行人:", currentStep.employeeIds);

      const targetRules = parseTargetRules(currentStep);
      Object.assign(initialValues, targetRules);

      const employeeIds = parseEmployeeIds(currentStep);
      initialValues.stepEmployeeIds = employeeIds;
      console.log("设置执行人IDs:", initialValues.stepEmployeeIds);
    }

    console.log("最终表单初始值:", initialValues);
    form.setFieldsValue(initialValues);
  };

  return {
    initFormData
  };
};

export default useStepFormInit; 